import { TooltipHelper } from "../../tooltipHelper";
import AnimatedNumber from "../../animatedNumber";
import { numFormatter } from "../../../helpers/utils";

interface IWidgetSectionProps {
  sectionRawValue: number;
  sectionPretext: string;
  sectionText: string;
  sectionDescription: string;
  tooltipText: string;
}

const WidgetSection = ({
  sectionRawValue,
  sectionPretext = "",
  sectionText = "",
  sectionDescription = "",
  tooltipText = ""
}: IWidgetSectionProps) => {
  const hasCurrency = sectionPretext.length > 0;

  return (
    <div className="section">
      {hasCurrency && <span className="currency-label">{sectionPretext}</span>}
      <TooltipHelper tooltipText={tooltipText} placement="top">
        <span className="value">
          <AnimatedNumber value={sectionRawValue} formatter={numFormatter} />
        </span>
      </TooltipHelper>
      <span className="text">{sectionText}</span>
      {sectionDescription && <span className="description">{sectionDescription}</span>}
    </div>
  );
};

export { WidgetSection };
